import {
  DEFAULT_LIMIT,
  fetchAllCursorPages,
  schedulingDelete,
  schedulingGet,
  schedulingPost,
  schedulingPut,
  versionBody,
  idempotencyHeaders,
} from "./client";

export function listAvailabilityRules({
  organizationRef,
  availabilityRuleId,
  scheduleId,
  active,
  cursor,
  limit = DEFAULT_LIMIT,
  signal,
  consistency,
}) {
  return schedulingGet("availability-rules", {
    organizationRef,
    availabilityRuleId,
    scheduleId,
    active,
    cursor,
    limit,
  }, { signal, consistency });
}

export async function listAllAvailabilityRules(params) {
  return fetchAllCursorPages({
    signal: params.signal,
    itemsKey: "availabilityRules",
    fetchPage: (cursor) => listAvailabilityRules({ ...params, cursor }),
  });
}

export function createAvailabilityRule(body, idempotencyKey) {
  return schedulingPost("availability-rules", body, {
    headers: idempotencyHeaders(idempotencyKey),
  });
}

export function updateAvailabilityRule(body) {
  const { expectedVersion, ...rest } = body;
  return schedulingPut("availability-rules", {
    ...rest,
    ...versionBody(expectedVersion),
  });
}

export function deactivateAvailabilityRule({ organizationRef, availabilityRuleId, expectedVersion }) {
  return schedulingDelete("availability-rules", {
    organizationRef,
    availabilityRuleId,
    ...versionBody(expectedVersion),
  });
}
